if (!customElements.get('size-chart')) {
  class SizeChart extends HTMLButtonElement {
    constructor() {
      super();
    }

    toggleDrawer() {
      if (this.SizeChart.classList.contains('open')) {
        this.close();
      } else {
        this.open();
      }
    }
    connectedCallback() {
      this.section = this.closest('section'); // Find the closest parent section element
      this.SizeChart = this.section.querySelector('size-chart-drawer'); // Find the size chart drawer within the section
      this.addEventListener('click', this.open.bind(this));

      this.data_close_drawer = this.SizeChart.querySelector('[data-drawer-close]');

      if (this.data_close_drawer) {
        this.data_close_drawer.addEventListener('click', () => {
          this.close();
        });
      }

      this.back_overlay = this.SizeChart.querySelector('[data-backdrop-overlay]');
      this.back_overlay.addEventListener('click', () => {
        this.close();
      });

      this.handleCursorMove();
    }
    handleCursorMove() {
      const cursorWrapper = this.SizeChart.querySelector('[data-cursor-hover]');

      gsap.set(cursorWrapper, { xPercent: -50, yPercent: -50 });

      const xTo = gsap.quickTo(cursorWrapper, 'x', { duration: 0.1, ease: 'power3' });
      const yTo = gsap.quickTo(cursorWrapper, 'y', { duration: 0.1, ease: 'power3' });

      this.back_overlay.addEventListener('mousemove', (e) => {
        gsap.to(cursorWrapper, { opacity: 1, scale: 1, duration: 0.1 });
        xTo(e.clientX);
        yTo(e.clientY);
      });
      this.back_overlay.addEventListener('mouseleave', (e) => {
        gsap.to(cursorWrapper, { scale: 0, duration: 0.1 });
      });
      this.back_overlay.addEventListener('mouseenter', (e) => {
        gsap.to(cursorWrapper, { scale: 1, duration: 0.1 });
      });
    }

    addEventListeners() {
      this.addEventListener('mouseenter', (e) => this.handleMouseEnter(e));
      this.addEventListener('mouseleave', (e) => this.handleMouseLeave(e));
    }

    open() {
      if (this.SizeChart) {
        setTimeout(() => {
          this.SizeChart.classList.add('open');
          document.body.classList.add('overflow-hidden');
        }, 200);
        setTimeout(() => {
          this.SizeChart.classList.add('shadow');
        }, 600);

        // Prevent scrolling when the drawer is open
        document.body.setAttribute('data-lenis-prevent', 'true');
      }
    }

    close() {
      if (this.SizeChart) {
        this.SizeChart.classList.remove('open');
        document.body.classList.remove('overflow-hidden');
        this.SizeChart.classList.remove('shadow');
        document.body.removeAttribute('data-lenis-prevent');
      }
    }
  }
  customElements.define('size-chart', SizeChart, { extends: 'button' });
}
if (!customElements.get('quantity-set')) {
  class QuantitySelector extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.isUpdating = false;
      this.input = this.querySelector('input');
      this.updateButtonState();
      this.handleShowMore();
      this.buttons = Array.from(this.querySelectorAll('.quantity-button'));

      this.buttons.forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
      this.input.addEventListener('change', this.onButtonClick.bind(this));
    }

    onButtonClick(event) {
      event.preventDefault();

      // Prevent multiple clicks if an update is already happening
      if (this.isUpdating) return;
      this.isUpdating = true;

      const previousValue = this.input.value;
      let step = parseInt(this.input.step);
      // Adjust the value based on the button clicked
      if (event.currentTarget.name === 'plus') {
        this.input.value = parseInt(this.input.value) + step; // Increment the value
      } else {
        this.input.value = parseInt(this.input.value) - step; // Decrement the value
      }

      // If the value has changed, dispatch the change event
      if (previousValue !== this.input.value) {
        const changeEvent = new Event('change', { bubbles: true, cancelable: true });
        this.input.dispatchEvent(changeEvent);
      }

      this.updateButtonState();

      // Reset the flag after a slight delay (you can adjust the delay as needed)
      setTimeout(() => {
        this.isUpdating = false;
      }, 100); // 100ms delay
    }

    updateButtonState() {
      const minusButton = this.querySelector('[name="minus"]');
      const plusButton = this.querySelector('[name="plus"]');

      // Disable the minus button if the value is 1
      if (parseInt(this.input.value) <= 1) {
        minusButton.disabled = true;
        this.input.value = parseInt(this.input.step);
      } else {
        minusButton.disabled = false;
      }
    }

    get showMoreButton() {
      return this.closest('section')?.querySelector('show-more-button button');
    }

    handleShowMore() {
      const isShowingMore = Boolean(this.showMoreButton);

      if (isShowingMore) {
        this.showMoreButton.addEventListener('click', (event) => {
          event.preventDefault();

          this.showMoreButton
            .closest('volume-pricing')
            .querySelectorAll('.show-more-item.hidden')
            .forEach((hiddenItem) => hiddenItem.classList.remove('hidden', 'show-more-item'));
          this.showMoreButton.classList.add('hidden');
        });
      }
    }
  }
  customElements.define('quantity-set', QuantitySelector);
}
if (!customElements.get('product-info')) {
  class ProductInfo extends HTMLElement {
    onVariantChangeUnsubscriber = void 0;
    cartUpdateUnsubscriber = void 0;
    abortController = void 0;
    pendingRequestUrl = null;
    preProcessHtmlCallbacks = [];
    postProcessHtmlCallbacks = [];
    constructor() {
      super();
      this.section = this.closest('section');
    }
    get sectionId() {
      return this.hasAttribute('data-original-section-id')
        ? this.getAttribute('data-original-section-id')
        : this.getAttribute('data-section-id');
    }
    get productId() {
      return this.getAttribute('data-product-id');
    }
    get productForm() {
      return this.querySelector('form[is="product-form"]');
    }
    get pickupAvailability() {
      return this.querySelector('pickup-availability');
    }
    get variantSelectors() {
      return this.querySelector('variant-selects');
    }
    get quantityInput() {
      return this.querySelector('quantity-input input');
    }
    get productLightbox() {
      return this.section.querySelector('[data-product-media-content]');
    }
    connectedCallback() {
      this.onVariantChangeUnsubscriber = theme.pubsub.subscribe(
        theme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
        this.handleOptionValueChange.bind(this)
      );
      this.initQuantityHandlers();
      this.dispatchEvent(
        new CustomEvent('product-info:loaded', {
          bubbles: !0,
        })
      );
    }

    disconnectedCallback() {
      this.onVariantChangeUnsubscriber(), this.cartUpdateUnsubscriber?.();
    }

    handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
      if (!this.contains(event.target)) return;

      this.resetProductFormState();

      const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
      this.pendingRequestUrl = productUrl;
      const shouldSwapProduct = this.dataset.url !== productUrl;
      const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
      this.renderProductInfo({
        requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
        targetId: target.id,
        callback: shouldSwapProduct
          ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
          : this.handleUpdateProductInfo(productUrl),
      });
    }
    resetProductFormState() {
      this.productForm?.handleErrorMessage(), this.productForm?.toggleSubmitButton(!0, '');
    }
    handleSwapProduct(productUrl, updateFullPage) {
      return (html) => {
        this.productModal?.remove();

        const selector = updateFullPage ? "product-info[id^='product-info']" : 'product-info';
        const variant = this.getSelectedVariant(html.querySelector(selector));
        this.updateURL(productUrl, variant?.id);
        this.section = this.closest('section');

        if (updateFullPage) {
          document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

          HTMLUpdateUtility.viewTransition(
            document.querySelector('main'),
            html.querySelector('main'),
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks
          );
        } else {
          HTMLUpdateUtility.viewTransition(
            this.section.querySelector('media-gallery'),
            html.querySelector('media-gallery'),
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks
          );
          HTMLUpdateUtility.viewTransition(
            this,
            html.querySelector('product-info'),
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks
          );
        }
      };
    }
    renderProductInfo({ requestUrl, targetId, callback }) {
      this.abortController?.abort(),
        (this.abortController = new AbortController()),
        fetch(requestUrl, {
          signal: this.abortController.signal,
        })
          .then((response) => response.text())
          .then((responseText) => {
            if (((this.pendingRequestUrl = null), callback !== void 0)) {
              const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
              callback(parsedHTML);
            }
          })
          .then(() => {
            const activeElement = document.getElementById(targetId);
            activeElement !== null &&
              (activeElement.hasAttribute('align-selected') &&
                activeElement.closest(activeElement.getAttribute('align-selected')).scrollTo({
                  left: activeElement.offsetLeft,
                  behavior: 'instant',
                }),
              setTimeout(() => {
                activeElement.focus({
                  preventScroll: !0,
                });
              }, 100));
          })
          .catch((error) => {
            error.name === 'AbortError' ? console.log('Fetch aborted by user') : console.error(error);
          });
    }
    buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
      const params = [];

      !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

      if (optionValues.length) {
        params.push(`option_values=${optionValues.join(',')}`);
      }

      return `${url}?${params.join('&')}`;
    }
    handleUpdateProductInfo(productUrl) {
      return (parsedHTML) => {
        const variant = this.getSelectedVariant(parsedHTML);

        this.pickupAvailability?.update(variant);
        this.updateOptionValues(parsedHTML);
        this.updateURL(productUrl, variant?.id);
        this.updateVariantInputs(variant?.id);

        if (!variant) {
          this.setUnavailable();
          return;
        }
        const updateSourceFromDestination = (id) => {
          const source = parsedHTML.getElementById(`${id}-${this.sectionId}-${this.productId}`);
          const destination = document.querySelector(`#${id}-${this.sectionId}-${this.productId}`);

          if (source && destination) {
            destination.innerHTML = source.innerHTML;
            destination.removeAttribute('hidden');
          }
        };

        const elementsToUpdate = ['Price', 'StickyPrice', 'Sku', 'Inventory', 'PricePerItem','quantity-main-product', 'Preorder', 'PreorderProps', 'PreorderIconGate'];

        elementsToUpdate.forEach(updateSourceFromDestination);

        if (!variant) {
          this.setUnavailable();
          return;
        }

        this.updateMedia(parsedHTML, variant?.featured_media?.id);

        this.updateQuantityRules(this.sectionId, this.productId, parsedHTML);

        this.productForm?.toggleSubmitButton(!variant.available, window.variantStrings.soldOut);

        this.updatePreorderState(variant);

        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: this.sectionId,
            productId: this.productId,
            parsedHTML,
            variant,
          },
        });

        (this.productForm ?? document).dispatchEvent(
          new CustomEvent('variant:change', {
            detail: { variant },
          })
        );
      };
    }

    getSelectedVariant(productInfoNode) {
      const selectedVariant = productInfoNode.querySelector('[data-selected-variant]')?.textContent;

      return selectedVariant ? JSON.parse(selectedVariant) : null;
    }
    // Pre-order (Preorder Manager app): the buy button's default label comes
    // from its data-pre-order attribute inside toggleSubmitButton, but that
    // attribute is variant-dependent, so refresh it (and the visible label)
    // from the per-variant JSON embedded by snippets/preorder-data.liquid.
    updatePreorderState(variant) {
      const dataEl = this.querySelector('[data-vell-preorder-data]');
      const btn = this.productForm?.submitButton;
      if (!dataEl || !btn || !variant) return;
      let stateMap;
      try {
        stateMap = JSON.parse(dataEl.textContent);
      } catch (error) {
        return;
      }
      const entry = stateMap[String(variant.id)];
      const isPreorder = !!entry && entry.mode === 'preorder';
      if (isPreorder) {
        btn.setAttribute('data-pre-order', 'true');
      } else {
        btn.removeAttribute('data-pre-order');
      }
      if (variant.available) {
        const textEl = btn.querySelector('[data-submit-button] span') || btn.querySelector('[data-submit-button]');
        if (textEl) {
          textEl.textContent = isPreorder
            ? entry.button || window.variantStrings.preOrder
            : window.variantStrings.addToCart;
        }
      }
    }
    updateOptionValues(parsedHTML) {
      const variantSelects = parsedHTML.getElementById(`VariantPicker-${this.sectionId}-${this.productId}`);
      variantSelects &&
        HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
    }
    updateURL(url, variantId) {
      this.querySelector('share-button')?.updateUrl(
        `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
      );

      if (this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
    }
    updateVariantInputs(variantId) {
      if (!variantId) return;
      document
        .querySelectorAll(
          `#ProductForm-${this.sectionId}-${this.productId}, #ProductFormInstallment-${this.sectionId}-${this.productId}`
        )
        .forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          (input.value = variantId ?? ''),
            input.dispatchEvent(
              new Event('change', {
                bubbles: !0,
              })
            );
        });
    }
    setUnavailable() {
      this.productForm?.toggleSubmitButton(!0, window.variantStrings.unavailable, !0);
      const selectors = ['Price', 'Inventory', 'Sku', 'PricePerItem', 'BackInStock', 'VolumeNote', 'QuantityRules']
        .map((id) => `#${id}-${this.sectionId}-${this.productId}`)
        .join(', ');
      document.querySelectorAll(selectors).forEach((selector) => selector.setAttribute('hidden', ''));
    }
    initQuantityHandlers() {
      this.quantityInput &&
        (this.setQuantityBoundries(),
        this.hasAttribute('data-original-section-id') ||
          (this.cartUpdateUnsubscriber = theme.pubsub.subscribe(
            theme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          )));
    }
    setQuantityBoundries() {
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.quantityBoundries, {
        data: {
          sectionId: this.sectionId,
          productId: this.productId,
        },
      });
    }
    fetchQuantityRules() { 
      const currentVariantId = this.productForm?.variantIdInput?.value;
      currentVariantId &&
        (this.querySelector('label[is="quantity-label"]')?.setAttribute('aria-busy', 'true'),
        fetch(`${this.getAttribute('data-product-url')}?variant=${currentVariantId}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.sectionId, this.productId, parsedHTML);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.querySelector('label[is="quantity-label"]')?.removeAttribute('aria-busy');
          }));
    }
    updateQuantityRules(sectionId, productId, parsedHTML) {
      this.quantityInput &&
        (theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.quantityRules, {
          data: {
            sectionId,
            productId,
            parsedHTML,
          },
        }),
        this.setQuantityBoundries());
    }
    updateMedia(parsedHTML, variantFeaturedMediaId) {
      if (!variantFeaturedMediaId) return;

      const id = 'MediaGallery';
      const source = parsedHTML.getElementById(`${id}-${this.sectionId}-${this.productId}`);
      const destination = document.querySelector(`#${id}-${this.sectionId}-${this.productId}`);

      if (source && destination) {
        destination.innerHTML = source.innerHTML;
        destination.removeAttribute('hidden');

        const primarySlider = destination.querySelector('[data-product-main-slider]');
        const thumbnailSlider = destination.querySelector('[data-product-thumbnail-slider]');

        if (primarySlider && thumbnailSlider) {
          const primaryInstance = theme.SwiperSlide(
            primarySlider,
            JSON.parse(primarySlider.getAttribute('data-swiper'))
          );
          const thumbnailInstance = theme.SwiperSlide(
            thumbnailSlider,
            JSON.parse(thumbnailSlider.getAttribute('data-swiper'))
          );

          primaryInstance.thumbs.swiper = thumbnailInstance;
          primaryInstance.thumbs.init();
        } else if (primarySlider) {
          const primaryInstance = theme.SwiperSlide(
            primarySlider,
            JSON.parse(primarySlider.getAttribute('data-swiper'))
          );
        }
      }
      if (this.productLightbox) {
        const sourceLightBox = parsedHTML.querySelector(`[data-product-media-content]`);
        const destinationLightbox = document.querySelector(`[data-product-media-content]`);
        if (sourceLightBox && destinationLightbox) {
          destinationLightbox.innerHTML = sourceLightBox.innerHTML;
        }
      }
    }
  }
  customElements.define('product-info', ProductInfo);
}
if (!customElements.get('product-form')) {
  class ProductForm extends HTMLFormElement {
    constructor() {
      super();
      this.section = this.closest('section');
      // this.variantIdInput.disabled = !1;
      const variantInputs = this.variantIdInput;

      if (variantInputs instanceof NodeList) {
        variantInputs.forEach((input) => (input.disabled = false));
      } else if (variantInputs) {
        variantInputs.disabled = false;
      }
      this.addEventListener('submit', this.onSubmitHandler);
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (this.section && this.section.querySelector('mix-and-match-bundle')) {
        this.bundle = this.section.querySelector('mix-and-match-bundle');
      }
    }
    get submitButton() {
      return (this._submitButton = this._submitButton || this.section.querySelector('[type="submit"]'));
    }
    get submitButtons() {
      return (this._submitButtons =
        this._submitButtons || document.querySelectorAll(`[type="submit"][form="${this.getAttribute('id')}"]`));
    }
    get hideErrors() {
      return this.getAttribute('data-hide-errors') === 'true';
    }
    get variantIdInput() {
      return this.querySelector('[name="id"]') || this.querySelectorAll('[name="id[]"]');
    }
    /*get variantIdInput() {
        return this.querySelector('[name="id"]')
    }*/
    onSubmitHandler(evt) {
      if (this.submitButton) {
        this.submitButton.querySelector('[data-submit-button]').classList.add('hidden');
        this.submitButton.querySelector('[data-submit-loader]').classList.remove('hidden');
      }

      evt.preventDefault();
      (this.activeElement = evt.submitter || evt.currentTarget), this.handleErrorMessage();
      const config = theme.utils.fetchConfig('javascript');
      (config.headers['X-Requested-With'] = 'XMLHttpRequest'), delete config.headers['Content-Type'];
      const formData = new FormData(this);
      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.section)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      for (var pair of formData.entries()) {
      }
      config.body = formData;
 
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });

            if(this.submitButton.querySelector('[data-submit-button]').getAttribute('data-gift-card') == false)
            {
              this.handleErrorMessage(response.message);
            }

            /*const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');*/
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) {
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
            this.error = false;
            if (this.bundle) {
              this.bundle.resetBundle();
            }

            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          // this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          if (this.submitButton) {
            this.submitButton.querySelector('[data-submit-loader]').classList.add('hidden');
            this.submitButton.querySelector('[data-submit-button]').classList.remove('hidden');
          }
        });
    }
    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.querySelector('[data-error-wrapper]');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('[data-error-message]');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
    toggleSubmitButton(disable = false, text, unavailable = false) {
      if (!this.submitButton) return;
      // Remove any previous attributes
      this.submitButton.removeAttribute('loading');
      this.submitButton.removeAttribute('unavailable');

      const submitButtonText = this.submitButton.querySelector('[data-submit-button]');
      const submitButtonTextChild = this.submitButton.querySelector('[data-submit-button] span');

      if (disable) {
        this.submitButton.setAttribute('disabled', '');
        if (unavailable) this.submitButton.setAttribute('unavailable', '');

        if (text) {
          (submitButtonTextChild || submitButtonText).textContent = text;
        } else {
          this.submitButton.setAttribute('loading', '');
        }
      } else {
        this.submitButton.removeAttribute('disabled');
        const defaultText =
          this.submitButton.getAttribute('data-pre-order') === 'true'
            ? window.variantStrings.preOrder
            : window.variantStrings.addToCart;

        (submitButtonTextChild || submitButtonText).textContent = defaultText;
      }
    }
  }
  customElements.define('product-form', ProductForm, {
    extends: 'form',
  });
}

if (!customElements.get('product-query-form')) {
  class ProductQueryForm extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('section');
      this.productForm = this.section?.querySelector('[data-product-query-form]');
      this.template = this.productForm.querySelector('template');
    }
    connectedCallback() {
      this.open_drawer = this.querySelector('[data-form-query]');
      this.addEventListener('click', (event) => {
        event.preventDefault();
        this.open();
        this.setActiveElement(this.open_drawer); //code added by neha
      });

      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.has('contact_posted') && urlParams.get('contact_posted') === 'true') {
        this.open();
      }
    }
    open() {
      if (!this.template) return;
      const content = this.template.content.firstElementChild.cloneNode(true);
      document.body.appendChild(content);

      this.popup = document.querySelector('product-query-drawer');
      this.backdropClose = this.popup.querySelector('[data-backdrop-overlay]');
      setTimeout(() => {
        this.popup?.classList.add('open');
        document.body.classList.add('overflow-hidden');
        document.body.setAttribute('data-lenis-prevent', 'true');
        this.addCloseListener();
        this.popup.addEventListener(
          //code added by neha
          'transitionend',
          () => {
            const containerToTrapFocusOn = this.popup;
            const focusElement = this.popup.querySelector('button.overlay-drawer-close');
            trapFocus(containerToTrapFocusOn, focusElement);
          },
          { once: true }
        );
      }, 200);

      this.handleCursorMove();
    }
    close() {
      if (this.popup) {
        this.popup.classList.remove('open');
        document.body.classList.remove('overflow-hidden');
        document.body.removeAttribute('data-lenis-prevent');
        removeTrapFocus(this.activeElement); // code added by neha
        this.popup.addEventListener(
          'transitionend',
          () => {
            this.popup.remove();
            this.popup = null;
          },
          { once: true }
        );
      }
    }
    setActiveElement(element) {
      // code added by neha
      this.activeElement = element;
    }
    handleCursorMove() {
      const cursorWrapper = this.popup.querySelector('[data-cursor-hover]');

      gsap.set(cursorWrapper, { xPercent: 0, yPercent: 0 });

      const xTo = gsap.quickTo(cursorWrapper, 'x', { duration: 0.1, ease: 'power3' });
      const yTo = gsap.quickTo(cursorWrapper, 'y', { duration: 0.1, ease: 'power3' });

      this.backdropClose.addEventListener('mousemove', (e) => {
        gsap.to(cursorWrapper, { opacity: 1, scale: 1, duration: 0.1 });
        xTo(e.clientX);
        yTo(e.clientY);
      });
      this.backdropClose.addEventListener('mouseleave', (e) => {
        gsap.to(cursorWrapper, { scale: 0, duration: 0.1 });
      });
      this.backdropClose.addEventListener('mouseenter', (e) => {
        gsap.to(cursorWrapper, { scale: 1, duration: 0.1 });
      });
    }

    addEventListeners() {
      this.addEventListener('mouseenter', (e) => this.handleMouseEnter(e));
      this.addEventListener('mouseleave', (e) => this.handleMouseLeave(e));
    }

    addCloseListener() {
      this.popup.addEventListener('click', (e) => {
        const isCloseButton = e.target.closest('[data-backdrop-overlay]');
        if (isCloseButton || e.target === this.popup) {
          this.close();
        }
      });
    }
  }
  customElements.define('product-query-form', ProductQueryForm);
}

if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.template = null;
      this.productForm = null;
      this.pairsWell = null;
      this.popup = null;
      this.productId = this.getAttribute('product-recommendations-id');
    }

    open(index) {
      if (!this.template) return;
      const content = this.template.content.firstElementChild.cloneNode(true);
      document.body.appendChild(content);

      this.popup = document.querySelector('cart-complementary');
      this.backdropClose = this.popup.querySelector('[data-backdrop-overlay]');
      if (this.popup.querySelector('[data-swiper]')) {
        const element = this.popup.querySelector('[data-swiper]');
        const properties = JSON.parse(element.getAttribute('data-swiper'));
        theme.SwiperSlide(element, properties);
      }
      setTimeout(() => {
        this.popup?.classList.add('open');
        document.body.classList.add('overflow-hidden');
        document.body.setAttribute('data-lenis-prevent', 'true');
        this.addCloseListener();
      }, 200);
      this.handleCursorMove();
    }
    handleCursorMove() {
      const cursorWrapper = this.popup.querySelector('[data-cursor-hover]');

      gsap.set(cursorWrapper, { xPercent: 0, yPercent: 0 });

      const xTo = gsap.quickTo(cursorWrapper, 'x', { duration: 0.1, ease: 'power3' });
      const yTo = gsap.quickTo(cursorWrapper, 'y', { duration: 0.1, ease: 'power3' });

      this.backdropClose.addEventListener('mousemove', (e) => {
        gsap.to(cursorWrapper, { opacity: 1, scale: 1, duration: 0.1 });
        xTo(e.clientX);
        yTo(e.clientY);
      });
      this.backdropClose.addEventListener('mouseleave', (e) => {
        gsap.to(cursorWrapper, { scale: 0, duration: 0.1 });
      });
      this.backdropClose.addEventListener('mouseenter', (e) => {
        gsap.to(cursorWrapper, { scale: 1, duration: 0.1 });
      });
    }

    addListener() {
      setTimeout(() => {
        this.pairsWell = this.querySelectorAll('[data-cart-pairs]');
        if (this.pairsWell.length > 0) {
          this.pairsWell.forEach((pair) => {
            pair.addEventListener('click', (event) => {
              event.preventDefault();
              const index = event.target.closest('[data-cart-pairs]').getAttribute('data-index');
              this.productForm = this.querySelector(`[data-complementary=drawer-${index}]`);

              if (this.productForm) {
                this.template = this.productForm.querySelector('template');
                this.open(index);
              }
            });
          });
        }
      }, 500);
    }

    connectedCallback() {
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = document.createElement('div');
          html.innerHTML = responseText;

          const escapedProductId = CSS.escape(parseInt(this.productId));

          const recommendations = html.querySelector(`[product-recommendations-id=${escapedProductId}]`);

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.addListener();
          }

          if (this.querySelector('[data-swiper]')) {
            const element = this.querySelector('[data-swiper]');
            const properties = JSON.parse(element.getAttribute('data-swiper'));
            theme.SwiperSlide(element, properties);
          }

          
            this.productCard = this.querySelector('[data-product-card]');
            if (this.productCard) {
              this.quickViewElement = this.productCard.querySelector('[data-quick-view]');
              if(this.quickViewElement){

                this.height = this.quickViewElement.offsetHeight;
                
                this.productCardlist = this.querySelectorAll('[data-product-card]');
                if (!this.productCardlist.length) return;
                
                this.productCardlist.forEach((item) => {
                  this.hoverOption = item.querySelector('[data-hover-option]');
                  if (this.hoverOption) {
                    this.hoverOption.style.setProperty('--quickview-height', `${this.height}px`);
                  }
                });
              }
            }
          
        })
        .catch((error) => {
          console.error('Error fetching recommendations:', error);
        });
    }

    addCloseListener() {
      const closeButton = this.popup?.querySelector('[data-backdrop-overlay]');
      const closeDrawerButton = this.popup?.querySelector('[data-close]');
      const closeCross = this.popup?.querySelector('[data-drawer-close]');

      const closePopup = () => {
        if (!this.popup) return;

        this.popup.classList.remove('open');
        document.body.classList.remove('overflow-hidden');
        document.body.removeAttribute('data-lenis-prevent');

        this.popup.addEventListener(
          'transitionend',
          () => {
            this.popup.remove();
            this.popup = null;
          },
          { once: true }
        );
      };
      if (closeDrawerButton) {
        closeDrawerButton.addEventListener('click', closePopup);
      }
      if (closeButton) {
        closeButton.addEventListener('click', closePopup);
      }
      if (closeCross) {
        closeCross.addEventListener('click', closePopup);
      }
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);
}
if (!customElements.get('product-interlinks')) {
  class ProductInterlinks extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('section');
      this.buttons = this.querySelectorAll('[data-tab-button]');
      this.interlinksWrapper = this.querySelector('[data-interlinks-wrapper]');
      this.interlinksInner = this.querySelector('[data-interlinks]');
      this.topGap = 20;
      this.bottomGap = 20;
      this.lastScrollY = 0;
      this.init();
    }

    init() {
      this.interLinkTabStickyHandler();
      window.addEventListener('scroll', () => {
        this.interLinkTabStickyHandler();
        this.interLinkTabActivationHandler();
      });

      if (this.buttons.length && this.interlinksInner) {
        this.setupListeners();
      }
    }

    getScrollDirection() {
      const currentScrollY = window.scrollY;
      const direction = currentScrollY > (this.lastScrollY || 0) ? 'down' : 'up';
      this.lastScrollY = currentScrollY;
      return direction;
    }

    setupListeners() {
      this.buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
          this.handleButtonClick(event.currentTarget);
        });
      });
    }

    interLinkTabStickyHandler() {
      const sectionBottom = this.section.getBoundingClientRect().bottom;
      const interlinksTop = this.interlinksWrapper.getBoundingClientRect().top;
      const interlinksBottom = this.interlinksWrapper.getBoundingClientRect().bottom;
      const headerType = document.querySelector('[data-header-type]').getAttribute('data-header-type');
      // const currentScrollY = window.scrollY;
      // const scrollDirection = currentScrollY > (this.lastScrollY || 0) ? "down" : "up";
      const scrollDirection = this.getScrollDirection();
      const touchHeight = document.querySelector('[data-header-type]').getBoundingClientRect().height + this.topGap;

      const addSticky = () => {
        this.classList.add('interlink-sticky');
        this.classList.remove('normal-state');
      };

      const removeSticky = () => {
        this.classList.remove('interlink-sticky');
        this.classList.add('normal-state');
      };

      if (scrollDirection === 'down') {
        if (headerType === 'on-scroll-up' && interlinksTop <= this.topGap) {
          addSticky();
        } else if (headerType === 'sticky-always' && interlinksTop <= touchHeight) {
          addSticky();
        } else if (headerType !== 'on-scroll-up' && interlinksTop <= this.topGap) {
          addSticky();
        }
      } else if (scrollDirection === 'up') {
        if (sectionBottom >= interlinksBottom + this.bottomGap) {
          removeSticky();
        } else if (headerType === 'on-scroll-up' && interlinksTop <= this.topGap) {
          addSticky();
        } else if (headerType === 'sticky-always' && interlinksTop <= touchHeight) {
          addSticky();
        }
      }

      // this.lastScrollY = currentScrollY;
    }

    interLinkTabActivationHandler() {
      const scrollDirection = this.getScrollDirection();
      document.querySelectorAll('section').forEach((section) => {
        const sectionTop = section.getBoundingClientRect().top;
        const sectionBottom = section.getBoundingClientRect().bottom;
        const sectionId = section.getAttribute('id'); // Assuming sections have IDs

        if (scrollDirection === 'down') {
          if (sectionTop <= 0 && sectionBottom > 0) {
            // this.setActive(sectionId);
            if (document.querySelector(`[data-id="${sectionId}"]`)) {
              this.updateActiveButton(document.querySelector(`[data-id="${sectionId}"]`));
              this.updateActiveInterlink(document.querySelector(`[data-id="${sectionId}"]`).getAttribute('data-index'));
            }
          }
        } else if (scrollDirection === 'up') {
          if (sectionBottom > 0 && sectionTop < window.innerHeight) {
            // this.setActive(sectionId);
            if (document.querySelector(`[data-id="${sectionId}"]`)) {
              this.updateActiveButton(document.querySelector(`[data-id="${sectionId}"]`));
              this.updateActiveInterlink(document.querySelector(`[data-id="${sectionId}"]`).getAttribute('data-index'));
            }
          }
        }
      });
    }

    interLinkTabActivationHandler() {
      const scrollDirection = this.getScrollDirection();
      let activeUpdated = false;

      document.querySelectorAll('section').forEach((section) => {
        const sectionTop = section.getBoundingClientRect().top;
        const sectionBottom = section.getBoundingClientRect().bottom;
        const headerOffset = document.querySelector('[data-header-type]')?.getBoundingClientRect().height || 0;

        if (activeUpdated) return;

        if (scrollDirection === 'down') {
          if (sectionTop <= 0 && sectionBottom > 0) {
            this.activateSection(section.getAttribute('id'));
            activeUpdated = true;
          }
        } else if (scrollDirection === 'up') {
          if (sectionBottom > 0 && sectionTop < window.innerHeight) {
            this.activateSection(section.getAttribute('id'));
            activeUpdated = true;
          }
        }
      });
    }

    activateSection(sectionId) {
      const matchingButton = document.querySelector(`[data-id="${sectionId}"]`);
      if (matchingButton && !matchingButton.classList.contains('active')) {
        this.updateActiveButton(matchingButton);
        this.updateActiveInterlink(matchingButton.getAttribute('data-index'));
      }
    }

    deactivateSection(sectionId) {
      const matchingButton = document.querySelector(`[data-id="${sectionId}"]`);
      if (matchingButton && matchingButton.classList.contains('active')) {
        matchingButton.classList.remove('active');
      }
    }

    handleButtonClick(button) {
      const activeIndex = button.dataset.index;
      const sectionId = button.dataset.id;

      // Update active class
      this.updateActiveButton(button);

      // Update --active-interlink property
      this.updateActiveInterlink(activeIndex);

      // Scroll to the section
      this.scrollToSection(sectionId);
    }

    updateActiveButton(activeButton) {
      this.buttons.forEach((button) => button.classList.remove('active'));
      activeButton.classList.add('active');
    }

    updateActiveInterlink(activeIndex) {
      if (this.interlinksInner) {
        this.interlinksInner.style.setProperty('--active-interlink', activeIndex);
      }
    }

    /*scrollToSection(sectionId) {
    const targetSection = document.getElementById(sectionId);
    if (targetSection) {
      targetSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    } else {
      console.warn(`Section with ID '${sectionId}' not found.`);
    }
  }*/

    scrollToSection(sectionId) {
      const targetSection = document.getElementById(sectionId);
      if (targetSection) {
        const headerOffset = document.querySelector('[data-header-type]')?.getBoundingClientRect().height || 0;
        const sectionTop = targetSection.getBoundingClientRect().top + window.scrollY + 1;
        const targetScrollPosition = sectionTop;

        window.scrollTo({
          top: targetScrollPosition,
          behavior: 'smooth',
        });
      } else {
        console.warn(`Section with ID '${sectionId}' not found.`);
      }
    }
  }

  customElements.define('product-interlinks', ProductInterlinks);
}
